module.exports = __webpack_public_path__ + "onboarding-cowboy.3285f36a413d3267dbcbf8aaca96e453.hashedasset.svg";